import { computed, onUnmounted, ref } from "@vue/composition-api";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export function useMaxCurrentSubscription(userId: string) {
  const { authUser } = useAuthUser();
  const maxCurrentSubscription = ref<Subscription | null>(null);
  const loading = ref(false);
  const amount = computed(() => (maxCurrentSubscription.value ? maxCurrentSubscription.value.amount : 0));

  const getActiveSubscriptions = async (providerId: string = userId, consumerId: string) => {
    return await providers.SubscriptionProvider.search({
      data: {
        providerId,
        consumerIds: [consumerId],
        expired: false,
      },
    });
  };

  const getMaxCurrentSubscription = async (providerId: string = userId) => {
    if (!authUser.value) return;
    const subscriptions = await getActiveSubscriptions(providerId, authUser.value.id);
    if (!!subscriptions) {
      maxCurrentSubscription.value = subscriptions.result.reduce((acc, curr) => {
        if (acc) {
          return acc.amount > curr.amount ? acc : curr;
        }
        return curr;
      }, null as Subscription | null);
    }
  };

  const onSubscribed = (newSubscription: Subscription | undefined) => {
    if (newSubscription && newSubscription.providerId === userId && newSubscription.amount > amount.value) {
      maxCurrentSubscription.value = newSubscription;
    }
  };

  emitter.on<Subscription>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);

  onUnmounted(() => {
    emitter.off<Subscription>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
  });

  return {
    amount,
    loading,
    maxCurrentSubscription,
    getMaxCurrentSubscription,
  };
}
